import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-filters-time',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './filters-time.component.html',
    styleUrl: './filters-time.component.scss'
})
export class FiltersTimeComponent {
  @Input() priceKwh = 0.00;
  @Input() activeFilter: 'today' | '7days' | '30days' | 'month' | 'currentYear' | 'previousYear' | 'custom' = 'today';
  @Input() customStartDate: string = '';
  @Input() customEndDate: string = '';
  @Input() showPriceFilter: boolean = true; // Nueva propiedad para controlar visibilidad del filtro de precio

  @Output() filterChange = new EventEmitter<string>();
  @Output() customDateChange = new EventEmitter<{ startDate: string; endDate: string }>();
  @Output() priceChange = new EventEmitter<number>();
  @Output() monthSelected = new EventEmitter<{ startDate: string; endDate: string; monthLabel: string }>();

  selectedMonthLabel: string | null = null;
  showMonthDropdown = false;
  selectedMonthIndex: number | null = null;
  months = [
    { index: 0, label: 'month1' },
    { index: 1, label: 'month2' },
    { index: 2, label: 'month3' },
    { index: 3, label: 'month4' },
    { index: 4, label: 'month5' },
    { index: 5, label: 'month6' },
    { index: 6, label: 'month7' },
    { index: 7, label: 'month8' },
    { index: 8, label: 'month9' },
    { index: 9, label: 'month10' },
    { index: 10, label: 'month11' },
    { index: 11, label: 'month12' }
  ];

  showPriceInput: boolean = false;

  toggleMonthDropdown(): void {
    this.activeFilter = 'month';
    this.showMonthDropdown = !this.showMonthDropdown;
    this.filterChange.emit('month');
  }

  selectMonth(monthIdx: number): void {
    const year = new Date().getFullYear();
    this.customStartDate = `${year}-${String(monthIdx + 1).padStart(2, '0')}-01`;
    const lastDay = new Date(year, monthIdx + 1, 0).getDate();
    this.customEndDate = `${year}-${String(monthIdx + 1).padStart(2, '0')}-${String(lastDay).padStart(2, '0')}`;

    this.selectedMonthIndex = monthIdx;
    this.selectedMonthLabel = this.months[monthIdx].label;
    this.showMonthDropdown = false;

    this.monthSelected.emit({
      startDate: this.customStartDate,
      endDate: this.customEndDate,
      monthLabel: this.selectedMonthLabel
    });
  }

  onFilterChange(filterType: string): void {
    this.activeFilter = filterType as any;
    this.filterChange.emit(filterType);
  }

  onCustomDateChange(): void {
    if (this.activeFilter === 'custom') {
      this.customDateChange.emit({
        startDate: this.customStartDate,
        endDate: this.customEndDate
      });
    }
  }

  savePrice(): void {
    this.priceChange.emit(this.priceKwh);
  }
}
